import { useEffect } from 'react';

var index = (function (ref) {
  var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var windowKeyDown = function windowKeyDown(e) {
    // Auto-focus the current input when a key is typed
    if (!(e.ctrlKey || e.metaKey || e.altKey)) {
      ref.current.focus();
    }
  };

  useEffect(function () {
    if (active) {
      window.addEventListener('keydown', windowKeyDown);
    } else {
      window.removeEventListener('keydown', windowKeyDown);
    }

    return function () {
      if (active) {
        window.removeEventListener('keydown', windowKeyDown);
      }
    };
  }, [active]);
});

export { index as default };
